<!-- Rebate Request - Display Mode -->
<app-rebate-request #rebateRequest (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)"></app-rebate-request>
<div  class="form-container" *ngIf="showGrid">
    <div class="read-only-content">
        <div class="form-section">
            <h4 class="section-title">Formulated Approved Decision</h4>
            <!-- Formulated Decision -->
            <div class="form-group">
                <label for="lblFormulatedDecision">Formulated Decision</label>
                <label name="FormulatedDecision" id="lblFormulatedDecision" class="form-control read-only-textarea">
                    <pre>{{longHaulRequestRequestorDecisionResponse.FormulatedDecision}}</pre>
                </label>
            </div>
        </div>
         <!-- Options Grid -->
         <div class="table-responsive">
            <table class="table table-bordered table-striped table-services">
                <thead>
                    <tr>
                        <th><span>From</span></th>
                        <th><span>To</span></th>
                        <th><span>Rebate Percentage in Numbers</span></th>
                        <th><span>Notes</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let longHaulRequestOption of longHaulRequestRequestorDecisionResponse.LongHaulRequestOptionsFormulatedDecision; let i = index;">
                        <td>{{longHaulRequestOption.LastPortOfOrigin}}</td>
                        <td>{{longHaulRequestOption.FirstPortOfDestination}}</td>
                        <td>
                            <span *ngIf="longHaulRequestOption.RebatePercentage != '-' && longHaulRequestOption.RebatePercentage != '--'">{{longHaulRequestOption.RebatePercentage}}</span>
                            <span *ngIf="longHaulRequestOption.RebatePercentage == '-' || longHaulRequestOption.RebatePercentage == '--'">No Rebate granted</span>
                        </td>
                        <td>{{longHaulRequestOption.EconomicCommitteeNotes}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<app-messaging></app-messaging>
